import { Component, OnInit, Input } from '@angular/core';
import { InvoiceService } from '../../../../shared/services/invoice.service';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-invoice-item',
  templateUrl: './edit-invoice-item.component.html',
  styleUrls: ['./edit-invoice-item.component.scss']
})
export class EditInvoiceItemComponent implements OnInit {

  @Input() invoiceItem: any;
  @Input() invoiceId: number;
  @Input() caseId: number;
  
  feeType: number = 1;

  feeTypes: any = [];
  feeTypeName: string = "Professional Charge";

  editInvoiceItemDetails = this.fb.group({
    invoiceItemId: [],
    description: [],
    net: [],
    addVat: false,
    outlayId: [],
    nominalCode: []
  }, { });

  constructor(private invoiceService: InvoiceService,
              public activeModal: NgbActiveModal,
              private fb: UntypedFormBuilder) {
  }

  ngOnInit(): void {

     this.feeType = this.invoiceItem.feeType;

    // Set the title based on the API enum description
    this.invoiceService.getFeeTypes().subscribe((response : any) => {      
      this.feeTypes = response;
      this.feeTypeName = this.feeTypes.filter(x => x.key == this.feeType)[0].value;
    });

    this.editInvoiceItemDetails.controls["invoiceItemId"].patchValue(this.invoiceItem.id);
    this.editInvoiceItemDetails.controls["description"].patchValue(this.invoiceItem.description);
    this.editInvoiceItemDetails.controls["net"].patchValue(this.invoiceItem.net);

    if(this.invoiceItem.vat > 0)
      this.editInvoiceItemDetails.controls["addVat"].patchValue(true);
  }

  editInvoiceItem(){
    this.invoiceService.editInvoiceItem( this.caseId, this.invoiceId, this.editInvoiceItemDetails.value ).subscribe((response : any) => {
      this.activeModal.close(true);
    });
  }
}
